/**
 * Hero Block — JS module
 *
 * Handles:
 *  - Video play/pause toggle (native video only)
 *  - Swiper slider initialisation
 */

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

/**
 * Initialise the hero video play/pause toggle.
 * Works only on native <video> elements (not YouTube/Vimeo iframes).
 */
function initHeroVideo() {
    const btn = document.getElementById('heroVideoToggle');
    if (!btn) return;

    const section = btn.closest('.hero');
    if (!section) return;

    const video = section.querySelector('.hero__video');
    if (!video) return;

    const iconPause = btn.querySelector('.hero__video-controls-icon--pause');
    const iconPlay = btn.querySelector('.hero__video-controls-icon--play');

    btn.addEventListener('click', function () {
        if (video.paused) {
            video.play();
            iconPause.style.display = '';
            iconPlay.style.display = 'none';
            btn.setAttribute('aria-label', 'Pause video');
        } else {
            video.pause();
            iconPause.style.display = 'none';
            iconPlay.style.display = '';
            btn.setAttribute('aria-label', 'Play video');
        }
    });
}

/**
 * Initialise the hero Swiper slider.
 */
function initHeroSlider() {
    const sliderEl = document.getElementById('hero-swiper');
    if (!sliderEl) return;

    new Swiper(sliderEl, {
        modules: [Navigation, Pagination, Autoplay, A11y],
        loop: true,
        speed: 800,
        autoplay: false, // {
        //     delay: 50000,
        //     disableOnInteraction: false,
        // },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
        },
        pagination: {
            el: sliderEl.querySelector('.hero__slider-pagination'),
            clickable: true,
        },
        navigation: {
            nextEl: sliderEl.closest('.hero').querySelector('.hero__slider-btn--next'),
            prevEl: sliderEl.closest('.hero').querySelector('.hero__slider-btn--prev'),
        },
    });
}

export function init() {
    initHeroVideo();
    initHeroSlider();
}
